import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { DetailEmailLinkComponent } from '../detail-email-link/detail-email-link.component';
import { DetailPhoneLinkComponent } from '../detail-phone-link/detail-phone-link.component';
import { DetailViewModule } from '../../detail-view.module';
import type { Contact } from './contact';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-contact',
    templateUrl: './detail-contact.component.html',
    styleUrls: ['./detail-contact.component.scss'],
    imports: [
        DetailEmailLinkComponent,
        DetailPhoneLinkComponent,
        DetailViewModule,
    ],
})
export class DetailContactComponent {
    public title = input<string>();

    public contact = input.required<Contact>();

    public name = computed(() => {
        const contact = this.contact();
        const position = contact.position;

        return position
            ? `${ contact.firstName } ${ contact.lastName } (${ contact.position })`
            : `${ contact.firstName } ${ contact.lastName }`;
    });
}
